import styled from "styled-components";
import {DialogConsumerContentDefaultBox} from "./dialog-consumer-content.default.box";

export const DialogConsumerContentCasino777Box = styled(DialogConsumerContentDefaultBox)`
  background-color: ${props => props.theme.colors.brandSecondaryLight}
`